<template>
  <div class="h-screen flex w-full
        bg-img vx-row no-gutter
        justify-center padding_forget_password" 
      id="page-forget-password">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/5 sm:m-0 m-4">
      <vx-card class="border-radius-default">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-start items-start bg-primary border-radius-default">
            <h4 class="m-2 text-white">ログインパスワード設定</h4>
          </div>        
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-8 pt-2 login-tabs-container">
                <div class="vx-card__title mb-2">
                  <div class="font-size-info">
                    <p>パスワード設定用のリンクをメールで送信します。</p>
                    <p >メールアドレスを入力して［送信］ボタンをクリックしてください。</p>  
                  </div>
                </div>
                <div class="grid">
                  <vs-row class="mt-5 mb-3">
                    <vs-col vs-type="flex" vs-align="flex-end" vs-w="3">
                      <label for="email" class="pb-2">メールアドレス</label>
                    </vs-col>
                    <vs-col vs-type="flex" vs-align="center" vs-w="9">
                      <vs-input
                          id="email"
                          name="メールアドレス"
                          icon-no-border
                          icon-pack="feather"
                          label-placeholder="email@your.domain"
                          v-model="email"
                          v-validate="'required|email'"
                          class="w-full inputx"
                      />
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-w="9" vs-offset="3">
                      <span style="color: red">{{ errors.first("メールアドレス") | convertError }}</span>
                    </vs-col>
                  </vs-row>
                </div>
                <div class="grid">
                  <vs-row class="mt-2" vs-justify="space-between">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
                      <router-link to="login">ログイン画面に移動</router-link>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
                      <vs-button @click="submitRequest">送信</vs-button>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      email: '',
      
    }
  },
  methods: {
    ...mapActions({
      forgotPassword: "passwordModule/forgotPassword"
    }),

    async submitRequest() {
       this.$validator.validateAll().then((result) => {
        if (result) {
          let params = {
            email: this.email,
          };
         this.forgotPassword(params);
        }
      });
    }
  }
}
</script>